import smartSolveApi from './instances/smartsolve';

export const getCacheList = async () => {
  try {
    const response = await smartSolveApi.post('/getcachelist', {});

    return response.data;
  } catch (e) {
    throw new Error(`getcachelist() failed: ${e}`);
  }
};

export const cleanupCaches = async () => {
  try {
    const response = await smartSolveApi.post('/cleanupcaches ', {});

    return response.data;
  } catch (e) {
    throw new Error(`cleanupcaches () failed: ${e}`);
  }
};
